import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { InView } from 'react-intersection-observer';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { BiData } from '@wix/da-bi/pkg/events';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import CarouselIcon from '@wix/da-ds/pkg/Icons/24x24/Carousel';
import noop from '../../utils/noop';
import EmptyBackground from '../../DeviationBackground/StageBackground/EmptyBackground';
import { ADDITIONAL_MEDIA_ID_PREFIX, BI_SCROLL_SECTIONNAME, SCROLL_MODE_THRESHOLD_FOR_INVIEW } from '../constants';
import { useMobileStage } from '../hooks/useMobileStage';
import { useScrollToCurrentlyViewed } from '../hooks/useScrollToCurrentlyViewed';
import FullImageSourceWithCaption from '../_partials/FullImageSourceWithCaption';
import styles from './MobileArtStage.scss';
/** Multi-image deviation that displays as a vertical list of images one above the other */ const MobileMultiArtScrollStage = ({ deviation, additionalMedia = [], currentlyViewedImageSource, setCurrentlyViewedImageSource = noop, isZoomed, onEnterZoomMode = noop, onExitZoomMode = noop, setDisplayMode = noop })=>{
    const { t } = useTranslation();
    const { contentSize = {} } = useMobileStage(deviation);
    // if there's a currentlyViewedImageSource, scroll to it
    const isScrolling = useScrollToCurrentlyViewed(deviation, additionalMedia, currentlyViewedImageSource);
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: BI_SCROLL_SECTIONNAME
    }, /*#__PURE__*/ React.createElement(EmptyBackground, null), /*#__PURE__*/ React.createElement(IconButton, {
        className: styles['switch-to-carousel-button'],
        icon: CarouselIcon,
        size: "large",
        "aria-label": t('deviationview.artstage.changeToCarouselMode.altLabel'),
        onClick: ()=>{
            setDisplayMode('carousel');
            window.scrollTo(0, 0);
        },
        biData: BiData({
            evid: 309,
            deviationid: deviation.deviationId,
            view_mode: 'carousel'
        })
    }), /*#__PURE__*/ React.createElement("ol", {
        className: classnames(styles['scroll-mode-list'], isScrolling && styles['scroll-mode-list-scrolling'])
    }, /*#__PURE__*/ React.createElement(InView, {
        key: "original-deviation",
        as: "li",
        threshold: SCROLL_MODE_THRESHOLD_FOR_INVIEW,
        onChange: (inView)=>{
            inView && !isScrolling && setCurrentlyViewedImageSource(deviation);
        }
    }, /*#__PURE__*/ React.createElement(FullImageSourceWithCaption, _object_spread_props(_object_spread({
        key: "original-deviation",
        id: "deviation-image",
        deviationOrAttachment: deviation,
        dontExpandWrapper: true,
        withoutZoomModal: true
    }, contentSize), {
        isZoomed: isZoomed,
        onEnterZoomMode: onEnterZoomMode,
        onExitZoomMode: onExitZoomMode
    }))), additionalMedia.map((image, i)=>{
        return /*#__PURE__*/ React.createElement(InView, {
            key: `additional-media-${image.filename}`,
            as: "li",
            threshold: SCROLL_MODE_THRESHOLD_FOR_INVIEW,
            onChange: (inView)=>{
                inView && !isScrolling && setCurrentlyViewedImageSource(image);
            }
        }, /*#__PURE__*/ React.createElement(FullImageSourceWithCaption, _object_spread_props(_object_spread({
            key: `additional-media-${image.filename}`,
            id: `${ADDITIONAL_MEDIA_ID_PREFIX}${i}`,
            deviationOrAttachment: image,
            dontExpandWrapper: true,
            withoutZoomModal: true
        }, contentSize), {
            isZoomed: isZoomed,
            onEnterZoomMode: onEnterZoomMode,
            onExitZoomMode: onExitZoomMode
        })));
    })));
};
MobileMultiArtScrollStage.displayName = 'MobileMultiArtScrollStage';
export default MobileMultiArtScrollStage;

//# sourceMappingURL=MobileMultiArtScrollStage.js.map